<template>
	<v-form ref="form" @submit.prevent="validate">
		<v-select
			:loading="dc4.loadingUsers"
			v-model="dc4.formChangePass.dc4usuario"
			:items="dc4.users"
			prepend-icon="mdi-account"
			label="Usuário"
			required
			color="secondary"
			:rules="userRules"
			:disabled="$route.params.dc4usuario != null"
			no-data-text="Nenhum usuário cadastrado"
			id="user"
			item-value="dc4usuario"
			item-text="dc4nome"
			item-color="secondary" />
		<v-text-field
			id="oldDc4senha2"
			label="Senha antiga"
			prepend-icon="mdi-lock"
			v-model="dc4.formChangePass.oldDc4senha2"
			required
			:placeholder="getLabel('dc4senha2')"
			type="password"
			color="secondary"
			:rules="passwordRules" />
		<v-text-field
			id="dc4senha2"
			label="Nova senha"
			prepend-icon="mdi-lock"
			:placeholder="getLabel('dc4senha2')"
			type="password"
			v-model="dc4.formChangePass.dc4senha2"
			required
			color="secondary"
			:rules="getRules('dc4senha2')" />
		<v-card flat class>
			<v-card-text class="pa-0">
				<v-text-field
					v-model="dc4.formChangePass.dc4confsen"
					:placeholder="getLabel('dc4senha2')"
					label="Confirmação de senha"
					type="password"
					:color="this.dc4.formChangePass.dc4senha2 === this.dc4.formChangePass.dc4confsen ? 'secondary' : 'error'"
					prepend-icon="mdi-lock"
					:rules="[...getRules('dc4senha2'), ...dc4confsenRules]"/>
			</v-card-text>
			<v-card-text class="pa-0"> Senha deve conter pelo menos um número (0-9). </v-card-text>
			<v-card-text class="pa-0"> Senha deve conter pelo menos um caractere especial (!@#$%^&*). </v-card-text>
			<v-card-text class="pa-0">
				Senha deve conter pelo menos uma letra maiúscula (A-Z) e uma letra minúscula (a-z).
			</v-card-text>
			<v-card-text class="pa-0"> Senha deve conter pelo menos 8 caracteres. </v-card-text>
		</v-card>
		<div class="text-left text-body-2 pt-3">
			<router-link :to="{ name: 'login' }" class="secondary--text"> &lt; Realizar login </router-link>
		</div>
		<div v-if="dc4.formChangePass.error" class="text-center text-body-2 red--text pt-3">
			{{ dc4.formChangePass.error }}
		</div>
		<div class="text-center pt-4">
			<v-btn :loading="dc4.formChangePass.loading" color="secondary" large type="submit" text rounded>
				Alterar senha</v-btn
			>
		</div>
	</v-form>
</template>

<script>
	import formMixin from "@/plugins/mixins/formMixin"
	import mixin from "@/plugins/mixins/mixin"

	export default {
		mixins: [formMixin, mixin],
		data() {
			return {
				userRules: [v => !!v || "Usuário é obrigatório"],
				newPassRules: [v => !!v || "A nova senha é obrigatória"],
				passwordRules: [v => !!v || "A senha é obrigatória"],
			}
		},
		computed: {
			dc4: {
				get() {
					return this.$store.state.dc4
				},
			},
			lstDc1: {
				get() {
					return this.$store.state.form.lstDc1
				},
			},
			passwordMatches() {
				return this.dc4.formChangePass.dc4senha2 === this.dc4.formChangePass.dc4confsen
			},
			dc4confsenRules() {
				return [
					v => (this.dc4.formChangePass.dc4senha2 != "" ? !!v : true) || "Confirmação de senha é obrigatória",
					v => this.passwordMatches || "As senhas não coincidem",
				]
			},
		},
		methods: {
			validate() {
				if (this.$refs.form.validate() && this.passwordMatches) {
					this.$store.dispatch("dc4/changePass")
				}
			},
		},
		mounted() {
			if (this.$route.params.dc4troca) {
				this.dc4.formChangePass.error = "Senha expirada! Realize a troca e faça login novamente."
			}
			if (this.$route.params.dc4usuario) {
				this.$store.dispatch("dc4/setFormChangePassDc4usuario", this.$route.params.dc4usuario)
			}
		},
	}
</script>

<style scoped>
	#password >>> input {
		-webkit-text-security: circle !important;
	}
</style>
